/**
 * EmailTemplate Entity
 * Represents an email template in the system
 */
export class EmailTemplate {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly description: string | null,
    public readonly subject: string,
    public readonly htmlContent: string,
    public readonly variables: string[],
    public readonly category: EmailCategory,
    public readonly isActive: boolean,
    public readonly isSystem: boolean,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly createdBy: string | null,
    public readonly workspaceId: number | null
  ) {}

  /**
   * Check if template can be edited (system templates have limited editing)
   */
  canEdit(): boolean {
    return !this.isSystem || this.isActive !== undefined;
  }

  /**
   * Check if template can be deleted
   */
  canDelete(): boolean {
    return !this.isSystem;
  }

  /**
   * Get category label in Spanish
   */
  getCategoryLabel(): string {
    return EMAIL_CATEGORY_LABELS[this.category];
  }
}

export type EmailCategory =
  | 'welcome'
  | 'auth'
  | 'notification'
  | 'marketing'
  | 'general';

export const EMAIL_CATEGORY_LABELS: Record<EmailCategory, string> = {
  welcome: 'Bienvenida',
  auth: 'Autenticación',
  notification: 'Notificación',
  marketing: 'Marketing',
  general: 'General',
};

export const EMAIL_CATEGORIES: EmailCategory[] = [
  'welcome',
  'auth',
  'notification',
  'marketing',
  'general',
];
